import { IWorkExperience, IScoredExperience, ICompareVectorsResult } from "types";
import { getUnixTimestamp, getPastDate, getFutureDate, compareVectors } from "utils";

// TODO: Consolidate this so that we only send one request to the AI function instead of always iterating through 1 experience at a time.

export const scoreExperienceSingle = async (
  experience: IWorkExperience,
  compareAgainst?: string,
): Promise<IScoredExperience|Error> => {
  const payload = compareAgainst && await compareVectors(experience.itemId, [compareAgainst]);
  if (payload instanceof Error) return payload;
  const scoredExperience: IScoredExperience = {
    workExperience: experience,
    score: payload && 'results' in payload ? (payload as ICompareVectorsResult).results[0].score : 0,
  };

  return scoredExperience;
};

export const scoreExperiences = async (
  experiences: IWorkExperience[],
  compareAgainst: string,
): Promise<IScoredExperience[]> => {
  const scoredExperiences: IScoredExperience[] = [];
  for (const experience of experiences) {
    const scoredExperience = await scoreExperienceSingle(experience, compareAgainst);
    if (!(scoredExperience instanceof Error)) {
      scoredExperiences.push(scoredExperience);
    }
  }
  return scoredExperiences;
};

export const rescoreExperiences = async (
  scoredExperiences: IScoredExperience[],
  compareAgainst: string,
): Promise<IScoredExperience[]> => {
  const rescoredExperiences: IScoredExperience[] = [];
  for (const scoredExperience of scoredExperiences) {
    const rescoredExperience = await scoreExperienceSingle(
      scoredExperience.workExperience,
      compareAgainst,
    );
    if (!(rescoredExperience instanceof Error)) {
      rescoredExperiences.push(rescoredExperience);
    }
  }
  return rescoredExperiences;
};

export const scoreExperienceWithinRange = async (
  experiences: IWorkExperience[],
  compareAgainst?: string,
  startDate?: string,
  endDate?: string,
): Promise<IScoredExperience[]> => {
  const experiencesToScore: IWorkExperience[] = [];
  const today = new Date();
  const startDateForRange = startDate ? startDate : getPastDate(today.toString(), 36500, false);
  const endDateForRange = endDate ? endDate : getFutureDate(today.toString(), 1, false);
  experiences.map((experience: IWorkExperience) => {
    const experienceDate = experience.completionDate ? experience.completionDate : experience.dateCreated;
    if (
      getUnixTimestamp(experienceDate) < getUnixTimestamp(endDateForRange) &&
      getUnixTimestamp(experienceDate) > getUnixTimestamp(startDateForRange)
    ) {
      experiencesToScore.push(experience);
    }
  });
  if (compareAgainst) {
    const scoredExperiences = await scoreExperiences(experiencesToScore, compareAgainst);
    return scoredExperiences;
  } else {
    const unscoredExperiences: IScoredExperience[] = experiencesToScore.map((experience: IWorkExperience) => {
      return {
        workExperience: experience,
        score: 0,
      };
    });
    return unscoredExperiences;
  }
};
